import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const WorklistsRoutes: RouteBundle = {
  domain: 'worklists',
  routes: [
    {urlPattern: 'worklists', handler: EditorRoutes.worklists.bind(EditorRoutes), legacy: true},
    {urlPattern: 'worklist-items', handler: EditorRoutes.worklistItems.bind(EditorRoutes), legacy: true},
  ],
};
